import notificationService from './notificationService.js';

class ToastService {
  constructor() {
    this.toasts = [];
    this.listeners = [];
    this.nextId = 1;
  }

  // Add a listener for toast updates
  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  // Notify all listeners of toast updates
  notify() {
    this.listeners.forEach(listener => listener(this.toasts));
  }

  // Show a toast notification
  show(message, type = 'success', duration = 5000) {
    const toast = {
      id: this.nextId++,
      message,
      type,
      timestamp: Date.now(),
      duration
    };

    this.toasts.push(toast);
    this.notify();

    // Add to notification service for header notifications
    notificationService.addFromToast(toast);

    // Auto remove toast after duration
    if (duration > 0) {
      setTimeout(() => {
        this.remove(toast.id);
      }, duration);
    }

    return toast.id;
  }

  // Remove a specific toast
  remove(id) {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
    this.notify();
  }

  // Clear all toasts
  clear() {
    this.toasts = [];
    this.notify();
  }

  // Convenience methods for different toast types
  success(message, duration = 5000) {
    return this.show(message, 'success', duration);
  }

  info(message, duration = 5000) {
    return this.show(message, 'info', duration);
  }

  warning(message, duration = 5000) {
    return this.show(message, 'warning', duration);
  }

  error(message, duration = 5000) {
    return this.show(message, 'danger', duration);
  }
}

// Create and export a singleton instance
const toastService = new ToastService();
export default toastService;